<template>
  <v-dialog v-model="show" persistent max-width="600px">
    <v-card class="info-card">
      <v-toolbar color="#02779E" dark flat dense height="56">
        <v-btn icon disabled style="opacity: 0; pointer-events: none;">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-spacer />

        <v-toolbar-title class="text-h6 font-weight-medium white--text text-center text-truncate">
          Información sobre el formato de los archivos
        </v-toolbar-title>

        <v-spacer />

        <v-btn icon @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-6 text-body-1 info-text-color">
        <p class="mb-4 text-intro">
          El fichero debe ser un TXT que cumpla las siguientes directrices:
        </p>

        <div class="lista-directrices mb-6">
          <div>- Las separaciones entre los datos deben ser espacios</div>
          <div>- No debe incluir números decimales</div>
          <div>- Cada conjunto de datos debe estar en una línea</div>
          <div>- Los valores deben estar comprendidos entre 0 y 100 (son porcentajes)</div>
        </div>

        <p class="mb-2 text-intro">
          Cada fila debe componerse de las siguientes columnas:
        </p>

        <div class="mb-6">
          model humidity humidity10h humidity100h FLH FLW
        </div>

        <p class="mb-2 text-intro">Ejemplo:</p>

        <div>
          1 20 30 43 24 90<br>
          2 15 35 41 19 60
        </div>
      </v-card-text>

      <v-card-actions class="pb-6 px-10 justify-center">
        <v-btn
          depressed
          color="#E1F5FE"
          class="btn-descarga px-6"
          block
          height="48"
          @click="descargarEjemplo"
        >
          <span class="btn-label">Descargar fichero de ejemplo</span>
          <v-icon right color="#02779E">mdi-tray-arrow-down</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'VxInfoModelos',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    cerrar () {
      this.$emit('cerrar')
    },
    descargarEjemplo () {
      const contenido = `0 4 6 8 60 80
1 4 6 8 60 80
2 4 6 8 60 80
3 4 6 8 60 80
4 4 6 8 60 80
5 4 6 8 60 80
6 4 6 8 60 80
7 4 6 8 60 80
8 4 6 8 60 80
9 4 6 8 60 80
10 4 6 8 60 80
11 4 6 8 60 80
12 4 6 8 60 80
13 4 6 8 60 80`

      const blob = new Blob([contenido], { type: 'text/plain;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'sampleModels.txt')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
.info-text-color,
.code-text {
  color: rgba(0, 0, 0, 0.87);
}

.code-text {
  font-family: monospace, sans-serif;
  font-size: 1rem;
  line-height: 1.6;
}

.text-intro {
  font-size: 1rem;
  line-height: 1.5;
}

.lista-directrices div {
  margin-bottom: 4px;
  line-height: 1.5;
}

.btn-descarga {
  text-transform: none;
  border-radius: 4px;
}

.btn-label {
  color: #02779E;
  font-weight: 500;
  font-size: 1rem;
}
</style>
